const onDealHaUrl = (url: string): string => {
    try {
        // 使用 URL 对象解析传入的 URL
        const parsedUrl = new URL(url);

        // 检查哈希部分
        const hash = parsedUrl.hash;

        if (hash) {
            // 移除哈希的#，并将剩余内容作为 hash_key 添加到查询参数
            const hashKey = hash.substring(1);
            parsedUrl.hash = ''; // 清除 hash 部分
            const searchParams = parsedUrl.searchParams;

            // 添加 hash_key 参数到查询
            searchParams.set('hash_key', hashKey);
            parsedUrl.search = searchParams.toString(); // 更新查询参数
        }

        // 返回处理后的 URL
        return parsedUrl.toString();
    } catch (_error) {
        return url; // 返回原始 URL
    }
};
const onUpdateUrlByHaKey = (url: string): string => {
    try {
        // 使用 URL 对象解析传入的 URL
        const parsedUrl = new URL(url);

        // 获取查询参数
        const searchParams = parsedUrl.searchParams;

        // 检查是否有 hash_key 和 micro_app_id 参数
        const hashKey = searchParams.get('hash_key');
        const microAppId = searchParams.get('micro_app_id');

        if (hashKey && microAppId) {
            // 将 hash_key 的值设置为新的 hash
            window.location.hash = `#/${hashKey}`;
        }
        return url;
    } catch (_error) {
        return url; // 返回原始 URL
    }
};

export { onDealHaUrl, onUpdateUrlByHaKey };
